import React from "react";
import Sidebar from "../../Sidebar/Sidebar";
import ScholarLeague from "./ScholarLeague/ScholarLeague";
import "./EngageHomepage.css";

function EngageHomepageAchievements() {
  return (
    <main className="engage-homepage-shell">
      <Sidebar />
      <div className="engage-homepage engage-homepage--achievements">
        <section className="engage-homepage__achievements" aria-label="League achievements page">
          <ScholarLeague />
        </section>
      </div>
    </main>
  );
}

export default EngageHomepageAchievements;
